import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { EventFilterParam } from '../events/useGetAllEvents';
import { queryKeys } from '../queryKeys';

type UseGetEventsStatsParams = {
  filters: EventFilterParam;
};

type UseGetEventsStatsProps = {
  params: UseGetEventsStatsParams;
  enabled?: boolean;
};

interface EventsStatsResponse {
  events_count: number;
  employees_count: number;
}

const fetchDashboardEventsStats = async ({ params }: UseGetEventsStatsProps) => {
  const response = await CustomAxios.get<EventsStatsResponse>('dashboard/events-stats', {
    params,
  });
  return response.data;
};

export function useGetDashboardEventsStats({ params, enabled = true }: UseGetEventsStatsProps) {
  return useQuery({
    enabled,
    queryKey: [queryKeys.dashboardEvents, params],
    queryFn: () => fetchDashboardEventsStats({ params }),
    placeholderData: keepPreviousData,
  });
}
